import React from 'react';
import SimpleInfoModal from './SimpleInfoModal';
import Privacy from '../../../common/Privacy';

const PrivacyModal = (props) => {
    return (
        <SimpleInfoModal
            {...props}
            title="개인정보처리방침"
            maxWidth="max-w-md"
        >
            <Privacy />
        </SimpleInfoModal>
    );
};

export default PrivacyModal;